import { writable, readable } from 'svelte/store';

let currentTheme = localStorage.getItem('theme') !== null ? localStorage.getItem('theme') : 'white_theme';

export const isOpenMenu = writable(false);
export const initialMenuTransitionState = writable(true);
export const theme = writable(currentTheme);
export const isDarkTheme = writable(currentTheme === 'dark_theme' ? true : false);
export const projects = readable([
    {
        id: 'influenceidx',
        images: {
            modal: [
                '/images/templates/modal/influenceidx_1.jpg',
                '/images/templates/modal/influenceidx_2.jpg',
                '/images/templates/modal/influenceidx_3.jpg',
                '/images/templates/modal/influenceidx_4.jpg',
                '/images/templates/modal/influenceidx_5.jpg',
            ],
            thumbnails: {
                thumbnail_sm: '/images/templates/thumbnails/influenceidx-sm.jpg',
                thumbnail_lg: '/images/templates/thumbnails/influenceidx-lg.jpg',
            },
            technology: [
                'php.svg',
                'laravel.svg',
                'js.svg',
            ]
        },
        links: {
            project: 'https://influenceidx.com/'
        }
    },
    {
        id: 'tvshowreleasedate',
        images: {
            modal: [
                '/images/templates/modal/tvshowreleasedate_1.jpg',
                '/images/templates/modal/tvshowreleasedate_2.jpg',
            ],
            thumbnails: {
                thumbnail_sm: '/images/templates/thumbnails/tvshowreleasedate-sm.jpg',
                thumbnail_lg: '/images/templates/thumbnails/tvshowreleasedate-lg.jpg',
            },
            technology: [
                'php.svg',
                'wordpress.svg',
                'js.svg',
            ]
        },
        links: {
            project: ''
        }
    },
    {
        id: 'cavedivingaccident',
        images: {
            modal: [
                '/images/templates/modal/cavedivingaccident_1.jpg',
            ],
            thumbnails: {
                thumbnail_sm: '/images/templates/thumbnails/cavedivingaccident-sm.jpg',
                thumbnail_lg: '/images/templates/thumbnails/cavedivingaccident-lg.jpg',
            },
            technology: [
                'php.svg',
                'wordpress.svg',
            ]
        },
        links: {
            project: 'https://cavedivingaccident.com/'
        }
    },
    {
        id: 'robweiss',
        images: {
            modal: [
                '/images/templates/modal/robweiss_1.jpg',
                '/images/templates/modal/robweiss_2.jpg',
                '/images/templates/modal/robweiss_3.jpg',
            ],
            thumbnails: {
                thumbnail_sm: '/images/templates/thumbnails/robweiss-sm.jpg',
                thumbnail_lg: '/images/templates/thumbnails/robweiss-lg.jpg',
            },
            technology: [
                'php.svg',
                'wordpress.svg',
            ]
        },
        links: {
            project: 'https://robweissdesign.com/'
        }
    },
    {
        id: 'gamblingcentral',
        images: {
            modal: [
                '/images/templates/modal/gamblingcentral_1.jpg',
                '/images/templates/modal/gamblingcentral_2.jpg',
                '/images/templates/modal/gamblingcentral_3.jpg',
                '/images/templates/modal/gamblingcentral_4.jpg',
                '/images/templates/modal/gamblingcentral_5.jpg',
            ],
            thumbnails: {
                thumbnail_sm: '/images/templates/thumbnails/gamblingcentral-sm.jpg',
                thumbnail_lg: '/images/templates/thumbnails/gamblingcentral-lg.jpg',
            },
            technology: [
                'php.svg',
                'laravel.svg',
                'vue.svg',
            ]
        },
        links: {
            project: ''
        }
    },
    // {
    //     id: 'sci_fi',
    //     images: {
    //         modal: [
    //             '/images/templates/modal/sci_fi_1.jpg',
    //             '/images/templates/modal/sci_fi_2.jpg',
    //             '/images/templates/modal/sci_fi_3.jpg',
    //         ],
    //         thumbnails: {
    //             thumbnail_sm: '/images/templates/thumbnails/sci_fi-sm.jpg',
    //             thumbnail_lg: '/images/templates/thumbnails/sci_fi-lg.jpg',
    //         },
    //         technology: [
    //             'php.svg',
    //             'wordpress.svg',
    //         ]
    //     },
    //     links: {
    //         project: 'https://scifishooter.com/'
    //     }
    // },
    {
        id: 'studio',
        images: {
            modal: [
                '/images/templates/modal/studio_1.jpg',
                '/images/templates/modal/studio_2.jpg',
                '/images/templates/modal/studio_3.jpg',
            ],
            thumbnails: {
                thumbnail_sm: '/images/templates/thumbnails/studio-sm.jpg',
                thumbnail_lg: '/images/templates/thumbnails/studio-lg.jpg',
            },
            technology: [
                'php.svg',
                'wordpress.svg',
                'js.svg',
            ]
        },
        links: {
            project: ''
        }
    },
    {
        id: 'frozen',
        images: {
            modal: [
                '/images/templates/modal/frozen_1.jpg',
            ],
            thumbnails: {
                thumbnail_sm: '/images/templates/thumbnails/frozen-sm.jpg',
                thumbnail_lg: '/images/templates/thumbnails/frozen-lg.jpg',
            },
            technology: [
                'php.svg',
                'wordpress.svg',
                'js.svg',
            ]
        },
        links: {
            project: 'https://frozenhaze.com/'
        }
    }, 
    {
        id: 'simple',
        images: {
            modal: [
                '/images/templates/modal/simple_1.jpg',
            ],
            thumbnails: {
                thumbnail_sm: '/images/templates/thumbnails/simple-sm.jpg',
                thumbnail_lg: '/images/templates/thumbnails/simple-lg.jpg',
            },
            technology: [
                'php.svg',
                'wordpress.svg',
                'js.svg',
            ]
        },
        links: {
            project: ''
        }
    },
    {
        id: 'l-8',
        images: {
            modal: [
                '/images/templates/modal/l-8_1.jpg',
                '/images/templates/modal/l-8_2.jpg',
                '/images/templates/modal/l-8_3.jpg',
                '/images/templates/modal/l-8_4.jpg',
            ],
            thumbnails: {
                thumbnail_sm: '/images/templates/thumbnails/l-8-sm.jpg',
                thumbnail_lg: '/images/templates/thumbnails/l-8-lg.jpg',
            },
            technology: [
                'js.svg',
                'wordpress.svg',
            ]
        },
        links: {
            project: ''
        }
    },
    {
        id: 'jp',
        images: {
            modal: [
                '/images/templates/modal/jp_1.jpg',
            ],
            thumbnails: {
                thumbnail_sm: '/images/templates/thumbnails/jp-sm.jpg',
                thumbnail_lg: '/images/templates/thumbnails/jp-lg.jpg',
            },
            technology: [
                'js.svg',
            ]
        },
        links: {
            project: ''
        }
    },
    {
        id: 'cas',
        images: {
            modal: [
                '/images/templates/modal/cas_1.jpg',
            ],
            thumbnails: {
                thumbnail_sm: '/images/templates/thumbnails/cas-sm.jpg',
                thumbnail_lg: '/images/templates/thumbnails/cas-lg.jpg',
            },
            technology: [
                'php.svg',
                'wordpress.svg',
                'js.svg',
            ]
        },
        links: {
            project: ''
        }
    },
    {
        id: 'potato_store',
        images: {
            modal: [
                '/images/templates/modal/potato_store_1.jpg',
                '/images/templates/modal/potato_store_2.jpg',
                '/images/templates/modal/potato_store_3.jpg',
            ],
            thumbnails: {
                thumbnail_sm: '/images/templates/thumbnails/potato_store-sm.jpg',
                thumbnail_lg: '/images/templates/thumbnails/potato_store-lg.jpg',
            },
            technology: [
                'php.svg',
                'wordpress.svg',
                'woo.svg',
            ]
        },
        links: {
            project: ''
        }
    },
    {
        id: 'slime',
        images: {
            modal: [
                '/images/templates/modal/slime_1.jpg',
            ],
            thumbnails: {
                thumbnail_sm: '/images/templates/thumbnails/slime-sm.jpg',
                thumbnail_lg: '/images/templates/thumbnails/slime-lg.jpg',
            },
            technology: [
                'php.svg',
                'vue.svg',
            ]
        },
        links: {
            project: ''
        }
    },
    {
        id: 'gallery',
        images: {
            modal: [
                '/images/templates/modal/gallery_1.jpg',
                '/images/templates/modal/gallery_2.jpg',
            ],
            thumbnails: {
                thumbnail_sm: '/images/templates/thumbnails/gallery-sm.jpg',
                thumbnail_lg: '/images/templates/thumbnails/gallery-lg.jpg',
            },
            technology: [
                'php.svg',
                'wordpress.svg',
                'js.svg',
            ]
        },
        links: {
            project: ''
        }
    },
    {
        id: 'vue',
        images: {
            modal: [
                '/images/templates/modal/vue_1.jpg',
            ],
            thumbnails: {
                thumbnail_sm: '/images/templates/thumbnails/vue-sm.jpg',
                thumbnail_lg: '/images/templates/thumbnails/vue-lg.jpg',
            },
            technology: [
                'vue.svg',
            ]
        },
        links: {
            project: ''
        }
    },
    {
        id: 'movie',
        images: {
            thumbnails: {
                thumbnail_sm: '/images/templates/thumbnails/movie-sm.jpg',
                thumbnail_lg: '/images/templates/thumbnails/movie-lg.jpg',
            },
            technology: [
                'js.svg',
            ]
        },
        links: {
            project: 'https://www.potatosites.com/templates/movie-search/index'
        }
    },
    {
        id: 'business',
        images: {
            modal: [
                '/images/templates/modal/business_1.jpg',
            ],
            thumbnails: {
                thumbnail_sm: '/images/templates/thumbnails/business-sm.jpg',
                thumbnail_lg: '/images/templates/thumbnails/business-lg.jpg',
            },
            technology: [
                'js.svg',
            ]
        },
        links: {
            project: 'https://potatosites.com/templates/business/index'
        }
    },
    {
        id: 'column',
        images: {
            modal: [
                '/images/templates/modal/column_1.jpg',
            ],
            thumbnails: {
                thumbnail_sm: '/images/templates/thumbnails/column-sm.jpg',
                thumbnail_lg: '/images/templates/thumbnails/column-lg.jpg',
            },
            technology: [
                'php.svg',
                'wordpress.svg',
                'js.svg',
            ]
        },
        links: {
            project: ''
        }
    },
    {
        id: 'cross',
        images: {
            modal: [
                '/images/templates/modal/cross_1.jpg',
            ],
            thumbnails: {
                thumbnail_sm: '/images/templates/thumbnails/cross-sm.jpg',
                thumbnail_lg: '/images/templates/thumbnails/cross-lg.jpg',
            },
            technology: [
                'js.svg',
            ]
        },
        links: {
            project: 'https://potatosites.com/templates/cross/index'
        }
    },
    {
        id: 'blog',
        images: {
            modal: [
                '/images/templates/modal/blog_1.jpg',
            ],
            thumbnails: {
                thumbnail_sm: '/images/templates/thumbnails/blog-sm.jpg',
                thumbnail_lg: '/images/templates/thumbnails/blog-lg.jpg',
            },
            technology: [
                'php.svg',
                'wordpress.svg',
                'js.svg',
            ]
        },
        links: {
            project: ''
        }
    },
    {
        id: 'company',
        images: {
            modal: [
                '/images/templates/modal/company_1.jpg',
                '/images/templates/modal/company_2.jpg'
            ],
            thumbnails: {
                thumbnail_sm: '/images/templates/thumbnails/company-sm.jpg',
                thumbnail_lg: '/images/templates/thumbnails/company-lg.jpg',
            },
            technology: [
                'php.svg',
                'wordpress.svg',
                'js.svg',
            ]
        },
        links: {
            project: ''
        }
    },
    // {
    //     id: 'sweets',
    //     images: {
    //         modal: [
    //             '/images/templates/modal/sweets_1.jpg'
    //         ],
    //         thumbnails: {
    //             thumbnail_sm: '/images/templates/thumbnails/sweets-sm.jpg',
    //             thumbnail_lg: '/images/templates/thumbnails/sweets-lg.jpg',
    //         },
    //         technology: [
    //             'js.svg',
    //         ]
    //     },
    //     links: {
    //         project: 'https://www.potatosites.com/templates/sweets/index'
    //     }
    // },
    
    // {
    //     id: 'pacers',
    //     images: {
    //         modal: [
    //             '/images/templates/modal/pacers_1.jpg'
    //         ],
    //         thumbnails: {
    //             thumbnail_sm: '/images/templates/thumbnails/pacers-sm.jpg',
    //             thumbnail_lg: '/images/templates/thumbnails/pacers-lg.jpg',
    //         },
    //         technology: [
    //             'js.svg',
    //         ]
    //     },
    //     links: {
    //         project: 'https://potatosites.com/templates/pacers/index'
    //     }
    // },
    {
        id: 'nice_potato',
        images: {
            modal: [
                '/images/templates/modal/nice_potato_1.jpg'
            ],
            thumbnails: {
                thumbnail_sm: '/images/templates/thumbnails/nice_potato-sm.jpg',
                thumbnail_lg: '/images/templates/thumbnails/nice_potato-lg.jpg',
            },
            technology: [
                'js.svg',
            ]
        },
        links: {
            project: 'https://potatosites.com/templates/nice-potato/index'
        }
    },
    // {
    //     id: 'consoles',
    //     images: {
    //         modal: [
    //             '/images/templates/modal/consoles_1.jpg'
    //         ],
    //         thumbnails: {
    //             thumbnail_sm: '/images/templates/thumbnails/consoles-sm.jpg',
    //             thumbnail_lg: '/images/templates/thumbnails/consoles-lg.jpg',
    //         },
    //         technology: [
    //             'js.svg',
    //         ]
    //     },
    //     links: {
    //         project: 'https://www.potatosites.com/templates/consoles/index'
    //     }
    // },
    {
        id: 'city',
        images: {
            modal: [
                '/images/templates/modal/city_1.jpg'
            ],
            thumbnails: {
                thumbnail_sm: '/images/templates/thumbnails/city-sm.jpg',
                thumbnail_lg: '/images/templates/thumbnails/city-lg.jpg',
            },
            technology: [
                'php.svg',
                'wordpress.svg',
            ]
        },
        links: {
            project: ''
        }
    },
    {
        id: 'mdc',
        images: {
            modal: [
                '/images/templates/modal/mdc_1.jpg'
            ],
            thumbnails: {
                thumbnail_sm: '/images/templates/thumbnails/mdc-sm.jpg',
                thumbnail_lg: '/images/templates/thumbnails/mdc-lg.jpg',
            },
            technology: [
                'php.svg',
                'wordpress.svg',
            ]
        },
        links: {
            project: ''
        }
    },
   
        
], set => null );